const KnockoutType = {
  NATIONAL_TEAM: 'national_team',
  FINAL_PHASE: 'final_phase',
} as const;

export default KnockoutType;
